import Loadable from '../../components/loadable';

const InvoicePlanBulkRescheduleModal = Loadable({
  loader: () => import('../../pages/invoices/invoice_plan_bulk_reschedule_modal'),
  type: 'modal',
});

angular.module('gym').value('InvoicePlanBulkRescheduleModal', InvoicePlanBulkRescheduleModal);
